import React, { useEffect, useState } from "react";
import { Link, usePage } from "@inertiajs/react";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { useCurrencyParser } from "@/hooks";
import { ShareButton } from "./ShareButton";
import { Button } from "react-bootstrap";
import RegisButton from "./RegisButton";
import Price from "./Price";
import useCountDown from "@/hooks/useCountDown";
import { dayLeft } from "@/utils/DateUtils";

dayjs.locale("id");

export default function Hero(props) {
    
    const openRegisDay = dayLeft(`${props.registration_deadline}`); // how much day until registration closed

    const eventEnd = `${props.item.tgl_selesai} ${props.item.jam_selesai}`;

    const { storage_url } = usePage().props;
    
    // state for event with last registration date is h-1
    const [hours, minutes, seconds] = useCountDown(
        `${props.registration_deadline}`
    );

    // alert message component
    const DisplayAlert = (props) => {
        if (props.distance_event <= -1) {
            return (
                <div className="d-flex">
                    <img src="/images/icon/exclamation.svg" className="me-2" />
                    <p className="alert-text">
                        Mohon maaf event ini sudah berakhir
                    </p>
                </div>
            );
        } else if (
            props.distance_regis <= 0 &&
            hours <= 0 &&
            minutes <= 0 &&
            seconds <= 0
        ) {
            return (
                <div className="d-flex">
                    <img src="/images/icon/exclamation.svg" className="me-2" />
                    <p className="alert-text">
                        Mohon maaf pendaftaran event ini sudah ditutup
                    </p>
                </div>
            );
        } else if (props.remaining_ticket_quota <= 0) {
            return (
                <div className="d-flex">
                    <img src="/images/icon/exclamation.svg" className="me-2" />
                    <p className="alert-text">
                        Mohon maaf tiket event ini sudah habis
                    </p>
                </div>
            );
        } else if (props.remaining_ticket_quota <= 3) {
            return (
                <div className="d-flex">
                    <img src="/images/icon/exclamation.svg" className="me-2" />
                    <p className="alert-text">
                        Hanya tersisa {props.remaining_ticket_quota} tiket. Ayo
                        segera beli tiketmu!
                    </p>
                </div>
            );
        } else {
            return null;
        }
    };

    return (
        <section id="hero">
            {!props.isPreview && (dayLeft(eventEnd) < 0 ||
                props.remaining_ticket_quota <= 3 ||
                (openRegisDay <= 0 &&
                    hours <= 0 &&
                    minutes <= 0 &&
                    seconds <= 0)) && (
                    <div
                        className={`alert mb-4 py-4 ${dayLeft(eventEnd) <= 0 ? "alert-secondary" : "alert-warning"
                            }`}
                        role="alert"
                    >
                        <DisplayAlert
                            distance_regis={openRegisDay}
                            distance_event={dayLeft(eventEnd)}
                            remaining_ticket_quota={props.remaining_ticket_quota}
                            event={props.item}
                            hour={hours}
                        />
                    </div>
                )}
            <div className="poster-book-area">
                {/* row justify-content-between align-items-start */}
                <div className="">
                    {" "}
                    {/* col-lg-5 */}
                    <div className="highlight-poster px-sm-5 px-3 bg-poster text-center">
                        {props.item.poster_path ? (
                            <img
                                className="img-fluid"
                                src={`${storage_url}${props.item.poster_path}`}
                                alt="highlight-poster"
                            />
                        ) : (
                            <img
                                className="img-fluid rounded-lg"
                                src="/images/poster-not-available.png"
                                alt="poster-not-available"
                            />
                        )}
                    </div>
                </div>
                <div className="book-area">
                    {" "}
                    {/* col-lg-6 */}
                    {dayLeft(eventEnd) > 0 &&
                        props.remaining_ticket_quota > 0 &&
                        openRegisDay >= 0 &&
                        hours >= 0 &&
                        minutes >= 0 &&
                        seconds > 0 && (
                            <div className="booking-date-card">
                                {openRegisDay >= 1 ? (
                                    <p className="mb-0">
                                        Batas pendaftaran :{" "}
                                        <span>{openRegisDay} hari lagi</span>
                                    </p>
                                ) : (
                                    <div className="d-flex align-items-center minus-one-day">
                                        <p className="mb-0 mr-2">
                                            Batas pendaftaran :{" "}
                                        </p>
                                        <div className="card p-1">
                                            <h5 id="hour" className="mb-0">
                                                {hours}
                                                <small className="ml-1">
                                                    Jam
                                                </small>
                                            </h5>
                                        </div>
                                        <div className="text-white font-weight-bold mx-1">
                                            :
                                        </div>
                                        <div className="card p-1">
                                            <h5 id="minute" className="mb-0">
                                                {minutes}
                                                <small className="ml-1">
                                                    Menit
                                                </small>
                                            </h5>
                                        </div>
                                        <div className="text-white font-weight-bold mx-1">
                                            :
                                        </div>
                                        <div className="card p-1">
                                            <h5 id="second" className="mb-0">
                                                {seconds}
                                                <small className="ml-1">
                                                    Detik
                                                </small>
                                            </h5>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    <div className="event-data">
                        <img src="/images/icon/location.svg" alt="location" />
                        <span className="text-muted ms-1 align-middle">
                            {props.item.kota}
                        </span>
                        <h4 className="my-3">{props.item.nama}</h4>
                        {props.item.judul && (
                            <div>
                                <span className="text-muted">Topik Acara</span>
                                <h5 className="mt-1">{props.item.judul}</h5>
                            </div>
                        )}
                        <hr />
                        <div className="d-flex align-items-start">
                            {props.organizer.logo ? (
                                <img
                                    src={`${storage_url}${props.organizer.logo}`}
                                    alt=""
                                    width={45}
                                    className="rounded-circle mr-3"
                                />
                            ) : (
                                <img
                                    src="/images/logo-not-available.png"
                                    alt="logo-not-available"
                                    width={45}
                                    className="rounded-circle mr-3"
                                />
                            )}
                            <div className="d-flex flex-column ms-3">
                                <span className="text-muted">
                                    Penyelenggara
                                </span>
                                <h5 className="mt-1">
                                    <Link className="text-reset text-decoration-none" href={'/organizer/'+props.organizer.slug}>
                                        {props.organizer.nama}
                                    </Link>
                                </h5>
                            </div>
                        </div>
                        <div className="d-none d-md-block">
                            <Price minmaxHarga={props.minmax_harga}/>
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        <RegisButton
                            eventDay={dayLeft(eventEnd)}
                            hours={hours}
                            minutes={minutes}
                            seconds={seconds}
                            openRegisDay={openRegisDay}
                            isPreview={props.isPreview}
                            remainingTicketQuota={props.remaining_ticket_quota}
                            slug={props.item.slug}
                            accessCode={props.accessCode}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
